<template>
  <section>
    <b-form-row class='my-1'>
      <b-col cols=1><label>Name<span class="red">*</span></label></b-col>
      <b-col><input-merger required :dict=address.firstName :disabled=disabled /></b-col>
      <b-col><input-merger required :dict=address.lastName :disabled=disabled /></b-col>
    </b-form-row>
    <b-form-row class='my-1'>
      <b-col cols=2><label>Company</label></b-col>
      <b-col><input-merger :dict=address.company :disabled=disabled /></b-col>
    </b-form-row>
    <b-form-row class='my-1'>
      <b-col cols=1><label>Street<span class="red">*</span></label></b-col>
      <b-col><input-merger required :dict=address.street1 :disabled=disabled /></b-col>
      <b-col><input-merger :dict=address.street2 :disabled=disabled /></b-col>
    </b-form-row>
    <b-form-row class='my-1'>
      <b-col cols=1><label>City<span class="red">*</span></label></b-col>
      <b-col><input-merger required :dict=address.city :disabled=disabled /></b-col>
      <b-col cols=1><label>State<span class="red">*</span></label></b-col>
      <b-col>
        <input-merger v-if="niceStates.length > 0" required select :dict=address.regionCode :disabled=disabled :selectOptions=niceStates />
      </b-col>
      <b-col cols=1><label>Zip</label></b-col>
      <b-col><input-merger :dict=address.zip :disabled=disabled /></b-col>
    </b-form-row>
    <b-form-row class='my-1'>
      <b-col cols=1 />
      <b-col cols=3>
        <!-- <input-merger checkbox :dict=address.residential :disabled=disabled>Residential?</input-merger> -->
      </b-col>
      <b-col cols=1><label>Country<span class="red">*</span></label></b-col>
      <b-col><input-merger required select :dict=address.countryCode :disabled=disabled :selectOptions=niceCountries @input=setStates /></b-col>
      <b-col cols=1><label>Phone</label></b-col>
      <b-col><input-merger :dict=address.phoneNumber :disabled=disabled /></b-col>
    </b-form-row>
  </section>
</template>

<script>
import InputMerger from '../../utility/InputMerger'
import mergeService from '../../../services/orderMerge'
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    address: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      niceStates: [],
    };
  },
  components: {
    InputMerger,
  },
  watch: {
    countries() {
      this.setStates()
    }
  },
  computed: {
    ...mapGetters({
      countries: 'countries',
    }),
    niceCountries() {
      if (!this.countries) return []
      return Object.keys(this.countries).map(abbr => {
        return { text: `${abbr} | ${this.countries[abbr].name}`, value: abbr }
      })
    },
  },
  methods: {
    ...mapActions({
      getCountries: 'getCountries',
    }),
    setStates() {
      if (!this.countries || !this.address.countryCode) {
        this.niceStates = []
        return
      }
      if (!this.address.countryCode.edited) {
        this.address.countryCode.edited = mergeService.mergeField(this.address.countryCode)
      }

      let selectedCountry = this.countries[this.address.countryCode.edited]
      if (!selectedCountry) {
        console.warn('selectedCountry undefined?', this.address.countryCode.edited)
        this.niceStates = []
        return
      }

      this.niceStates = Object.keys(selectedCountry.states).map(abbr => {
        return { text: `${abbr} | ${selectedCountry.states[abbr] || '???'}`, value: abbr }
      })
    },
  },
  mounted() {
    this.getCountries()
  },
}
</script>

<style scoped>
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/sales-order/edit-order-2/AddressForm.vue